import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as ConsultTypes,
  Creators as ConsultActions,
} from '../ducks/Consult';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getConsult({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/consult/${payload}`)
    if (status === 200) {
      yield put(ConsultActions.getConsultSuccess(data));
    }else{
      Sentry.captureMessage('getConsult failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });

    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      ConsultActions.getConsultError('Error fetching statement')
    );
  }
}

function* getConsultWatcher() {
  yield takeLatest(ConsultTypes.GET_CONSULT, getConsult);
}

export default function* rootSaga() {
  yield all([
    fork(getConsultWatcher),
  ]);
}
